"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AffiliateOrderStatus = void 0;
var AffiliateOrderStatus;
(function (AffiliateOrderStatus) {
    AffiliateOrderStatus["Pending"] = "pending";
    AffiliateOrderStatus["Accepted"] = "accepted";
    AffiliateOrderStatus["Declined"] = "declined";
    AffiliateOrderStatus["Confirmed"] = "confirmed";
    AffiliateOrderStatus["Cancelled"] = "cancelled";
    AffiliateOrderStatus["Draft"] = "draft";
    AffiliateOrderStatus["Reserved"] = "reserved";
})(AffiliateOrderStatus || (exports.AffiliateOrderStatus = AffiliateOrderStatus = {}));
//# sourceMappingURL=AffiliateOrderStatus.js.map